import { omitBy } from 'lodash';
import { useLocation } from 'react-router';
import useReactRouter from 'use-react-router';
import { PartialRecord } from '../helpers/types';
import { parseQueryString } from '../helpers/url';

export function useRouter<
  T extends {
    [K in keyof T]?: string;
  } = object,
>() {
  return useReactRouter<T>();
}

export function useQueryParam(param: string, defaultValue?: any) {
  const { location } = useRouter();
  const qs = parseQueryString(location.search);

  return qs[param] || defaultValue;
}

/**
 * Hook that returns the current query string as an object
 * FIXME: replace with useSearchParams from react-router-dom?
 */
export function useSearch<T extends object>(
  defaults: T = {} as T,
  parsers: PartialRecord<keyof T, (input: string) => any> = {} as any,
): T {
  const location = useLocation();
  const qs = parseQueryString(location.search, false, parsers);

  return omitBy(
    {
      ...defaults,
      ...qs,
    },
    (_value, key) => key.startsWith('_'),
  ) as T;
}
